import React from 'react';
import { withTranslations, WithTranslations } from '../../../../utils/withTranslations';
import { ReactComponent as Info } from '../../../../Icons/Info.svg';
import { ReactComponent as ReadMoreArrowRight } from '../../../../Icons/ReadMoreArrowRight.svg';
import { ScreenStore } from '../../../stores/ScreenStore';
import { injectStoresV1 } from '../../../stores/injectStoresV1';
import s from './ReadMoreButton.scss';

interface ReadMoreButtonProps extends WithTranslations {
  dataHook?: string;
  screenStore: ScreenStore;
}

const ReadMoreButtonCmp: React.FC<ReadMoreButtonProps> = ({ screenStore, t, dataHook }) => {
  const handleClick = () => {
    screenStore.goToScreen('details');
  };

  return (
    <button onClick={handleClick} className={s.button} data-hook={dataHook}>
      <Info className={s.info} />
      <span>{t('template.newMobileFlow.preview.readMore')}</span>
      <ReadMoreArrowRight className={s.arrow} />
    </button>
  );
};

export const ReadMoreButton = withTranslations(injectStoresV1('screenStore')(ReadMoreButtonCmp));
